import React from 'react';
import { format, parseISO } from 'date-fns';
import { Flex } from 'rebass';
import StatusDot from '../Status/StatusDot';
import colors from '../../theme/colors';
import GridColumn from '@/components/Table/GridTable';

const columns: GridColumn<any>[] = [
  {
    header: 'Model',
    id: 'model',
    accessor: (assembly: any) => {
      return `${assembly.model.backflowAssemblyMake.name} ${assembly.model.name}`;
    },
    // width: 180,
  },
  {
    id: 'serialNumber',
    header: 'Serial',
    accessor: (assembly: any) => assembly.serialNumber,
    width: 130,
  },
  {
    header: 'Type',
    id: 'type',
    accessor: (row: any) => {
      return (row.type || '').replace(/_/g, ' ');
    },
    width: 100,
  },
  {
    header: 'Last Tested',
    id: 'testStatus',
    accessor: (row: any) => {
      const { lastTest } = row;
      const date =
        row.lastTestDate &&
        !row.lastTestDate.startsWith('00') &&
        format(parseISO(row.lastTestDate), 'M/d/yyyy');

      if (!lastTest?.finalResult || lastTest.finalResult === 'FAIL') {
        return (
          <Flex>
            <StatusDot status="error" mr="1" />
            {date}
          </Flex>
        );
      }

      if (lastTest.initialResult === 'FAIL') {
        return (
          <Flex>
            <StatusDot color={colors.failPass} mr="1" />
            {date}
          </Flex>
        );
      }

      return (
        <Flex>
          <StatusDot status="success" mr="1" />
          {date}
        </Flex>
      );
    },
    width: 110,
  },
  {
    id: 'location',
    header: 'Location',
    accessor: (assembly: any) => assembly.location,
    // width: 200,
  },
];

export default columns;
